/**
 * @generated SignedSource<<f3990947243fcdfa4de6d2916f7b00fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfirmShortCodeResult = "EMAIL_ADDRESS_CHANGE_CONFIRMED" | "EMAIL_ADDRESS_CONFIRMED" | "LOGGED_IN" | "TOTP_REQUIRED" | "%future added value";
export type ConfirmShortCodeInput = {
  code: string;
  emailAddress: string;
  invitedToSignWorkspaceDocumentId?: string | null;
  networkInviteSlug?: string | null;
  shouldSendDownloadExtensionEmail?: boolean | null;
};
export type useConfirmShortCodeMutation$variables = {
  input: ConfirmShortCodeInput;
};
export type useConfirmShortCodeMutation$data = {
  readonly confirmShortCode: {
    readonly result: ConfirmShortCodeResult | null;
    readonly visitor: {
      readonly userAccount: {
        readonly " $fragmentSpreads": FragmentRefs<"CurrentUserContext_userAccount" | "InquiryContextProvider_userAccount">;
      } | null;
    } | null;
  };
};
export type useConfirmShortCodeMutation = {
  response: useConfirmShortCodeMutation$data;
  variables: useConfirmShortCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConfirmShortCodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmShortCodePayload",
        "kind": "LinkedField",
        "name": "confirmShortCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CurrentUserContext_userAccount"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InquiryContextProvider_userAccount"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfirmShortCodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmShortCodePayload",
        "kind": "LinkedField",
        "name": "confirmShortCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Visitor",
            "kind": "LinkedField",
            "name": "visitor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccount",
                "kind": "LinkedField",
                "name": "userAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "analyticsUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingType",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTestAccount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomDomainConnection",
                    "kind": "LinkedField",
                    "name": "customDomains",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomDomainEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomDomain",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "domain",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContraImage",
                        "kind": "LinkedField",
                        "name": "avatarImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uid",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasActivePortfolioSubscription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "topIndependentStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFramerExpert",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "generalInquiryCtaIsVisible",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndependentPortfolioTemplateTheme",
                        "kind": "LinkedField",
                        "name": "independentPortfolioTemplateTheme",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndependentPortfolioTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkPreferences",
                        "kind": "LinkedField",
                        "name": "workPreferences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCurrentlyAvailable",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReceivedTestimonialConnection",
                        "kind": "LinkedField",
                        "name": "receivedTestimonials",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryProfessionalCategory",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayUsername",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userGroups",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userFeatures",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WaitListConnection",
                    "kind": "LinkedField",
                    "name": "waitLists",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WaitListEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WaitList",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nid",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "source": "PAID_PROJECT_INQUIRY"
                        }
                      },
                      (v6/*: any*/)
                    ],
                    "concreteType": "UserAccountPaidProjectV2Connection",
                    "kind": "LinkedField",
                    "name": "paidProjectsV2",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "paidProjectsV2(filter:{\"source\":\"PAID_PROJECT_INQUIRY\"},first:1)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": [
                            "APPROVED",
                            "ARCHIVED",
                            "PENDING",
                            "PENDING_REVISION",
                            "EXPIRED"
                          ]
                        }
                      },
                      (v6/*: any*/)
                    ],
                    "concreteType": "UserAccountCreatedJobPostingsConnection",
                    "kind": "LinkedField",
                    "name": "createdJobPostings",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "createdJobPostings(filter:{\"status\":[\"APPROVED\",\"ARCHIVED\",\"PENDING\",\"PENDING_REVISION\",\"EXPIRED\"]},first:1)"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4f88b30dfa21ee0b541a8e87613e86e",
    "id": null,
    "metadata": {},
    "name": "useConfirmShortCodeMutation",
    "operationKind": "mutation",
    "text": "mutation useConfirmShortCodeMutation(\n  $input: ConfirmShortCodeInput!\n) {\n  confirmShortCode(input: $input) {\n    result\n    visitor {\n      userAccount {\n        ...CurrentUserContext_userAccount\n        ...InquiryContextProvider_userAccount\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment CurrentUserContext_userAccount on UserAccount {\n  analyticsUserId\n  onboardingType\n  id\n  isTestAccount\n  customDomains {\n    count\n    edges {\n      node {\n        domain\n        status\n        id\n      }\n    }\n  }\n  emailAddress\n  profile {\n    id\n    avatarImage {\n      uid\n      id\n    }\n    hasActivePortfolioSubscription\n    topIndependentStatus\n    isFramerExpert\n    generalInquiryCtaIsVisible\n    independentPortfolioTemplateTheme {\n      id\n      template {\n        displayName\n        id\n      }\n    }\n    workPreferences {\n      isCurrentlyAvailable\n    }\n    receivedTestimonials {\n      count\n    }\n    primaryProfessionalCategory\n    firstName\n    lastName\n    title\n    displayUsername\n  }\n  userGroups\n  userFeatures\n  waitLists {\n    edges {\n      node {\n        id\n        nid\n      }\n    }\n  }\n}\n\nfragment InquiryContextProvider_userAccount on UserAccount {\n  paidProjectsV2(first: 1, filter: {source: PAID_PROJECT_INQUIRY}) {\n    count\n  }\n  createdJobPostings(first: 1, filter: {status: [APPROVED, ARCHIVED, PENDING, PENDING_REVISION, EXPIRED]}) {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "115f145b0b396bce76f35999ebfb3c0f";

export default node;
